import { IGetProjetoImpressaoByIdUseCase } from "../../../presentation/useCases/read/get_projeto_impressao_by_id_use_case";
import { ImpressaoProjetoModel } from "../../models/impressao_projeto";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetProjetoImpressaoByIdUseCase
 */

export class GetProjetoImpressaoByIdUseCase implements IGetProjetoImpressaoByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(idProjetoImpressao: number): Promise<ImpressaoProjetoModel> {
    return await this.repository.getProjetoImpressaoById(idProjetoImpressao);

  }
}
